import { render } from "./App.vue?vue&type=template&id=46c5f291"
const script = {}

import exportComponent from "C:\\Users\\admin\\Desktop\\transferPage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__